import React from 'react';
import { SText } from 'src/components/SText';
import { CircleBadge } from '../CircleBadge/CircleBadge';

type Props = {
  testID?: string;
  label: string;
  num: string;
  translatingOptions?: Record<string, unknown> | undefined;
};

export const StepText: React.FC<Props> = ({ label, translatingOptions, num, testID = 'StepText' }) => {
  return (
    <div data-testid={testID} className="flex flex-row items-center my-4">
      <CircleBadge num={num} />
      <SText translatingOptions={translatingOptions} label={label} classNames="text-gray-700 ml-2" />
    </div>
  );
};
